import { Urls } from '../../Shared/Api';

export default class ImageService {
    static getImageItems() {
        return fetch(Urls.homeImage.getData)
            .then(res => {
                return res.json();
            })
    }
}


// WEBPACK FOOTER //
// ./Src/Components/ImageGallery/ImageService.js